import { render, staticRenderFns } from "./DmEmpty.vue?vue&type=template&id=157eabba&scoped=true"
import script from "./DmEmpty.vue?vue&type=script&lang=js"
export * from "./DmEmpty.vue?vue&type=script&lang=js"
import style0 from "./DmEmpty.vue?vue&type=style&index=0&id=157eabba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157eabba",
  null
  
)

export default component.exports